import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from 'actions/utils';
import { ICommonResponseObject, IProforientaitonRecommendationEvents } from 'api/types';
import { IReducers } from 'reducers';
import genericReducers from 'reducers/genericReducer';
import { connectReducers } from 'utils';

import { GET_PROFORIENTATION_RECOMMENDATION_EVENTS } from '../actions';

export type ProforientationRecommendationEventsState =
  ICommonResponseObject<IProforientaitonRecommendationEvents | null>;

const initialState: ProforientationRecommendationEventsState = {
  content: null,
  loading: false,
};
const generic = genericReducers<ProforientationRecommendationEventsState>();
const proforientationRecommendationEvents: IReducers<ProforientationRecommendationEventsState> = {
  [GET_PROFORIENTATION_RECOMMENDATION_EVENTS[REQUEST]]: generic.get.request,
  [GET_PROFORIENTATION_RECOMMENDATION_EVENTS[SUCCESS]]: generic.get.success,
  [GET_PROFORIENTATION_RECOMMENDATION_EVENTS[FAILURE]]: generic.get.failure,
  [GET_PROFORIENTATION_RECOMMENDATION_EVENTS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, proforientationRecommendationEvents);
